<div mat-dialog-title>
  <span i18n class="title dialog-title">Схема экспорта csv файла</span>
  <button mat-button class="mat-icon-button" [mat-dialog-close]="undefined">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content *ngIf="csvSchemas$ | async as csvSchemas">
  <mat-form-field appearance="outline" class="dense-input w-full">
    <mat-label i18n>Схема экспорта</mat-label>
    <mat-select [(ngModel)]="selectedSchema">
      <mat-option *ngFor="let item of csvSchemas" [value]="item">
        <span>{{ item.name }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div mat-dialog-actions>
  <button
    i18n
    mat-raised-button
    class="mat-accent mr-4"
    [disabled]="!selectedSchema"
    [mat-dialog-close]="selectedSchema"
    >ОК</button
  >
  <button i18n mat-button [mat-dialog-close]="undefined">Отмена</button>
</div>
